export const getDocumentTypeFilter = state => state.documentType.filter
export const getDocumentVisualizationFilter = state => state.documentVisualization.filter

export const getDocumentTypeMetadataFilter = state => state.documentTypeMetadata.filter

export const getMetadataListFilter = state => state.documentTypeMetadata.metadataListModal.filter
